import axios from 'axios'

class statistical{
    statisticaltimer = null;
    statisticalgetdata(url,param,type='POST',contenttype='application/json')
    {
        const config = {
            headers: { 
                "content-type":contenttype,
            }
        };
        if (process.env.NODE_ENV == 'development') {
            config.headers.apptoken = 'bcARqH6Vy0Ew98LV5MDk7TBdFVDZgYtQBCVlhjASLVsGnNJ81nsil33uWm'
                    + 'AWcqnZzGYMR66ecpS06k6Z6cRWlg==';

            config.headers.ticket = '86qHdrWXN4XPRzYUWzGWOLcKIXgrD8RvYRPOIHHBpcOg1TnNsDcspBt2bLm4TEs1'
                    + 'WdFYhIcpBQJ4JBU7bEBIJHJFOYZDBsI07k8-0u3NAAmAaksWJEa4n8HXMQDjycCku9Ght41_KH6Kkued4dQo7w==';
        }

        if(type=='PATCH')
        {
          return new Promise((resolve,reject) => {
            axios.patch(url,param,config).then((res) => {
                resolve(res.data.Data);
              }) 
          })
        }else{
          return new Promise((resolve,reject) => {
            axios.post(url,param,config).then((res) => {
                resolve(res.data);
              }) 
            })      
        }
    }
    createobjectstring(info){
        let str = '';
        Object.getOwnPropertyNames(info).forEach((val,idx)=>{
            if(idx==0)
            {
              str+=val+"="+info[val];
            }else{
              str+="&"+val+"="+info[val];
            }
        });
        return str;
    }
    
    startstatistical(router)
    {
          router.afterEach((to, from, next) => {
          if(this.statisticaltimer){
            clearInterval(this.statisticaltimer);
            this.statisticaltimer = null;

          }
          if(to.name=='magazineOriginalReading'){
            return;
          }
          (async ()=>{
            let routeUrl1 = router.resolve({
                  name: to.name,
                  params: to.params
             });
            let routeUrl2 = router.resolve({
                  name: from.name,
                  params: from.params
             });
            let paramfirst ={};
            paramfirst.uri = window.location.origin+'/'+routeUrl1.href;
            paramfirst.referer = window.location.origin+'/'+routeUrl2.href;
            let firstrest = await this.statisticalgetdata(`/api/statistical/pageview/receive`,paramfirst);

            let param ={};
            param.pageTitle = document.title;
            param.screenWidth=window.screen.width;
            param.screenHeight=window.screen.height;
            param.screenAvailWidth=window.screen.availWidth;
            param.screenAvailHeight=window.screen.availHeight;
            param.windowOuterWidth=window.outerWidth;
            param.windowOuterHeight=window.outerHeight;
            param.windowInnerWidth=window.innerWidth;
            param.windowInnerHeight=window.innerHeight;
            let str = this.createobjectstring(param);
            await this.statisticalgetdata(`https://statistical.dps.qikan.cn/api/receiver/pageview/${firstrest}`,str,"POST",'application/x-www-form-urlencoded');
            this.statisticaltimer = setInterval(()=>{
                 this.statisticalgetdata(`https://statistical.dps.qikan.cn/api/receiver/pageview/${firstrest}`,str,'PATCH','application/x-www-form-urlencoded');
            },8000);
          })(); 
      })  
    }
}
export default new statistical
